import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { tracksWidth, arrowWidth } from "../../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Connector5GRed5HBlack5KBlue = ({ state, workState }) => (
	<g id="Track-5K-blue-connector" transform="translate(1464.000000, 392.000000)">
		<g strokeLinecap="round"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		>
			<TrackArrow
				transform="translate(22.054442, 382.889855) rotate(-74.000000) translate(-22.054442, -382.889855) "
				points="26.0544421 390.889855 18.0544421 382.889855 26.0544421 374.889855"
			/>

			<path
				d="M4,260.5 L22.294524,332.946315 C26.6840197,350.328718 26.3197764,368.571526 21.2399277,385.76486 M18.6166302,394.643713 L3,447.5"
				strokeWidth={tracksWidth}
			/>
		</g>
	</g>
);

export default Connector5GRed5HBlack5KBlue;
